import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedDataAccessFlamingoModule } from '@mode/shared/data-access-flamingo';
import { SharedDataAccessWebappModule } from '@mode/shared/data-access-webapp';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ChartFacade } from '@mode/charts/contract';
import { ChartService } from './chart.service';
import { ChartPlanEffects } from './chart/chart-plan.effects';
import { ChartEffects } from './chart/chart.effects';
import * as fromChart from './chart/chart.reducer';
import { ColorEffects } from './color/color.effects';
import { VizDesignerFacade } from './component-facades/viz-designer.component-facade';
import { FormatEffects } from './format/format.effects';

@NgModule({
  imports: [
    CommonModule,
    SharedDataAccessWebappModule,
    SharedDataAccessFlamingoModule,
    StoreModule.forFeature(fromChart.chartFeatureKey, fromChart.reducer),
    EffectsModule.forFeature([ChartEffects, ChartPlanEffects, ColorEffects, FormatEffects]),
  ],
  providers: [VizDesignerFacade, { provide: ChartFacade, useClass: ChartService }],
})
export class ChartsDomainModule {}
